import OptionConst from "@/const/Option";
import { ShinseiService } from "@/service/ShinseiService";
import { ShinseiKoyouKeiyakuTime, Yuukyuu, ZanYuukyuuRes } from "@/types/Shinsei";
import dayjs from "dayjs";
import { ref, computed } from "vue";

export function useYuukyuu() {
  const loading = ref(0) // APIで読み込みをする本数
  const isError = ref(false)
  const srv = new ShinseiService();
  const zanYuukyuu = ref<ZanYuukyuuRes>({
    user_id: 0,
    zan_yuukyuu: 0
  });
  const getZanYuukyuu = async (userId: number) => {
    loading.value++
    const res = await srv.zanYuukyuu(userId)
    loading.value--
    return res
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

    // 有休取得時間の計算
    // @type 1:1日、2:AM休, 3:PM休
    // @time 雇用契約の有休差し引き時間
    // @index 選択した行
    const getYuukyuuTime = (yuukyuuTaniType: number | null, sashihikiTimes: string | null, yuukyuu:Yuukyuu, koyouKeiyakuTime: ShinseiKoyouKeiyakuTime | null) => {
      let resTime
      if(!yuukyuuTaniType || !sashihikiTimes){
        return '0.00'
      }

      // 雇用契約の有休差し引き時間が指定されている場合、第1位優先度で差し引き時間を使用する。
      if(sashihikiTimes != "00:00:00"){
        // 申請の送信用データに設定
        const sashihikiTimesObject = dayjs(dayjs().format('YYYY/MM/DD') + ' ' + sashihikiTimes)
        yuukyuu.yuukyuu_times = sashihikiTimesObject.format('HH:mm')
        return (sashihikiTimesObject.hour() + sashihikiTimesObject.minute() / 60).toFixed(2);
      }

      // 雇用契約の有休差し引き時間が指定されていない場合、就業時間の通常時間を使用する。

      // 有休申請レコードが取得できない場合
      if(koyouKeiyakuTime === null || typeof koyouKeiyakuTime === 'undefined'){
        return '0.00'
      }

      // 就業時間の通常勤務時間が取得できない場合
      if(!koyouKeiyakuTime.tsuujouTime){
        return '0.00'
      }

      // 有休申請レコードの就業時間の通常時間が00:00:00の場合
      if(koyouKeiyakuTime.tsuujouTime == "00:00:00"){
        yuukyuu.yuukyuu_times = "00:00"
        return '0.00'
      }

      // AM有給しか取得できないかどうかのフラグを取得できる場合
      let canOnlyAmKinmu = koyouKeiyakuTime.canOnlyAmKinmu
      // PM有給しか取得できないかどうかのフラグを取得できる場合
      let canOnlyPmKinmu = koyouKeiyakuTime.canOnlyPmKinmu

      let isHannichi = koyouKeiyakuTime.isHannichi
      if((!isHannichi && !canOnlyAmKinmu && !canOnlyPmKinmu) && (yuukyuuTaniType === OptionConst.SHINSEI_DIV.AM || yuukyuuTaniType === OptionConst.SHINSEI_DIV.PM)){

        // console.log("!isHannichi && !canOnlyAmKinmu && !canOnlyPmKinmu) && (type == 2 || type == 3)")

        yuukyuu.yuukyuu_times = "00:00"
        return '0.00'
      }

      // 選択行の有休取得日の就業時間の通常時間
      let tsuujouTime = koyouKeiyakuTime.tsuujouTime

      const nowYMD = dayjs().format('YYYY/MM/DD')

      const yuukyuuTime = dayjs(nowYMD + ' ' + tsuujouTime)

      // 取得する有給取得時間を1日、AM休、PM休で分ける
      if(isHannichi){
        // 半日取得可の場合

        if(yuukyuuTaniType == OptionConst.SHINSEI_DIV.FULL_DAY){
          // 選択した有休タイプが1日有休の場合
          resTime = yuukyuuTime
        } else {
          // 選択した有休タイプがAM休、PM休の場合
          let half = yuukyuuTime.subtract(4, 'h')

          // console.log("選択した有休タイプがAM休、PM休の場合");
          // console.log("yuukyuuTime.format('HH:mm')");
          // console.log(yuukyuuTime.format('HH:mm'));

          // console.log("half.format('HH:mm')");
          // console.log(half.format('HH:mm'));

          // console.log("yuukyuuTime.format('HH:mm') > half.format('HH:mm')");
          // console.log(yuukyuuTime.format('HH:mm') > half.format('HH:mm'));

          // 4時間差し引き後の値と差引前の時間の差がマイナスになる場合
          // 3:00 - 4:00 = 23:00 等のケース
          if(yuukyuuTime.format('HH:mm') <= half.format('HH:mm')){
            yuukyuu.yuukyuu_times = "00:00"
            return '0.00'
          } else {
            resTime = half
          }
        }

      } else {

        // AM有給しか取得できないかどうかのフラグを取得できる場合
        let canOnlyAmKinmu = koyouKeiyakuTime.canOnlyAmKinmu
        // PM有給しか取得できないかどうかのフラグを取得できる場合
        let canOnlyPmKinmu = koyouKeiyakuTime.canOnlyPmKinmu

        if(canOnlyAmKinmu){
          // AM有給しか取得できない
          resTime = yuukyuuTime
        } else if (canOnlyPmKinmu){
          // PM有給しか取得できない
          resTime = yuukyuuTime
        } else {
          // 1日有休のみの場合
          resTime = yuukyuuTime
        }

      }

      // 申請の送信用データに設定
      yuukyuu.yuukyuu_times = resTime.format('HH:mm')

      // 画面表示用の有給取得時間の値を返す
      return (resTime.hour() + (Number(resTime.minute()) / 60)).toFixed(2)
    }

  return {
    getZanYuukyuu,
    isLoading,
    zanYuukyuu,
    getYuukyuuTime
  }
}
